module.exports = __webpack_public_path__ + "img/c07_unitlongship_Normal_ua.8379fc0f.webp";